export default __webpack_public_path__ + "static/media/pdficon.5375d62c.svg";